let debugAds = process.env.NODE_ENV !== "production";

export const ADS_CONFIG = {
  enabled: true, // Toggle all ads on/off globally
  provider: "adsense", // or "custom", "mediavine", etc.
  adClient: "ca-pub-8741993571156966",
  testMode: process.env.NODE_ENV !== "production",
  get debugAds() {
    return debugAds;
  },
  setDebugAds(val) {
    debugAds = val;
  },
  types: {
    banner: "4120534797",
    sidebar: "7568825217",
    inline: "9198559519"
  },
};